import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-75dc0a24"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "footer"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "footer-image"
  }, null, -1);
});

var _hoisted_3 = {
  class: "footer-box"
};
var _hoisted_4 = {
  class: "footer-text"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 「天若有情天亦老 ");

var _hoisted_6 = /*#__PURE__*/_createTextVNode(" 人间正道是沧桑」 ");

var _hoisted_7 = {
  class: "blog-run-time"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "smile-face"
  }, "ღゝ◡╹)ノ♡", -1);
});

var _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"copyright-container\" data-v-75dc0a24><p data-v-75dc0a24>© 2026 izxu.cn All Rights Reserved.</p><div class=\"beian-container\" data-v-75dc0a24><a class=\"beian-link\" href=\"https://beian.mps.gov.cn/#/query/webSearch?code=11010102000001\" target=\"_blank\" rel=\"noopener\" data-v-75dc0a24><img src=\"/beiantubiao.png\" class=\"police-icon\" alt=\"公安徽标\" data-v-75dc0a24> 皖公网安备34062102000263号 </a><a class=\"beian-link\" href=\"https://beian.miit.gov.cn/#/Integrated/index\" target=\"_blank\" rel=\"noopener\" data-v-75dc0a24> 皖ICP备2026022871号-1 </a></div></div>", 1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", null, [_createVNode(_component_font_awesome_icon, {
    icon: ['fas', 'heart-pulse'],
    class: "footer-text-icon"
  })]), _hoisted_6]), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_7, "网站已经运行了 " + _toDisplayString($setup.blogRunTime), 1), _hoisted_8]), _hoisted_9])]);
}